import React from "react";
import HomeUI from "./HomeUI";

const Home = () => {
  return <HomeUI />;
};

export default Home;
